import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

import { ISRMQuickbetPlaceBetModel } from '../../../quickbet/models/quickbet-place-bet.model';
import { IQuickbetReceiptDetailsModel, ISRMBetPlacementModel, IYCBetReceiptModel } from '../../../quickbet/models/quickbet-receipt.model';
import { IRemoteBetslipBet } from '../remoteBetslip/remote-betslip.constant';

@Injectable({ providedIn: 'root' })
export class QuickbetDataProviderService {
    private placeBetObservable: Subject<IRemoteBetslipBet>;
    private quickbetReceiptObservable: Subject<IQuickbetReceiptDetailsModel[] | IYCBetReceiptModel>;

    constructor() {
        this.placeBetObservable = new Subject<IRemoteBetslipBet>();
        this.quickbetReceiptObservable = new Subject<IQuickbetReceiptDetailsModel[] | IYCBetReceiptModel>();
    }

    get quickbetPlaceBetListener(): Subject<IRemoteBetslipBet | ISRMQuickbetPlaceBetModel> {
        return this.placeBetObservable;
    }
    set quickbetPlaceBetListener(value: Subject<IRemoteBetslipBet | ISRMQuickbetPlaceBetModel>) {}
    get quickbetReceiptListener(): Subject<IQuickbetReceiptDetailsModel[] | IYCBetReceiptModel | ISRMBetPlacementModel[]> {
        return this.quickbetReceiptObservable;
    }
    set quickbetReceiptListener(value: Subject<IQuickbetReceiptDetailsModel[] | IYCBetReceiptModel | ISRMBetPlacementModel[]>) {}
}
